import script from "./SignalInner.vue?vue&type=script&setup=true&lang=js"
export * from "./SignalInner.vue?vue&type=script&setup=true&lang=js"

import "./SignalInner.vue?vue&type=style&index=0&id=36c0378a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c0378a"]])

export default __exports__